import React, { Suspense } from 'react';
import { SubsectionContainer } from '../CourseHome.styles';
import PlayIcon from '../../../Visuals/Icons/PlayIcon.icon';
import PropTypes from 'prop-types';

const VideosContainer = ({ data }) => {
  return (
    <>
      <SubsectionContainer id="videos">
        <Suspense fallback={<div>Loading icon...</div>}>
          <PlayIcon />
        </Suspense>
        <h3>Videos</h3>
      </SubsectionContainer>
      <ul>
        {data?.videoLinks?.map((l) => {
          return (
            <li key={l}>
              <a
                href={l}
                target="_blank"
                rel="noreferrer"
                alt={'Video link to ' + l}
              >
                {l}
              </a>
            </li>
          );
        })}
      </ul>
    </>
  );
};
VideosContainer.propTypes = {
  data: PropTypes.shape({
    videoLinks: PropTypes.array,
  }),
};

export default VideosContainer;
